<div class="csu-wrapper" [class.csu-wrapper-inline]="renderMode === 'expanded'">
  @if (renderMode === 'pill') {
    <div class="csu-content csu-content-disabled" aria-hidden="true">
      <ng-content></ng-content>
    </div>
  }

  @if (renderMode === 'pill') {
    <button
      type="button"
      class="csu-pill"
      [class.csu-pill-inline]="pillMode === 'relative'"
      [class.csu-pill-open]="isOpen"
      [attr.data-pos]="pillPosition"
      (click)="toggleOpen()"
      [attr.aria-label]="(isOpen ? 'Close' : 'Open') + ' coming soon details for ' + title"
      >
      <span class="csu-pill-text">Coming Soon</span>
    </button>
  }

  @if (renderMode === 'expanded') {
    <div class="csu-card csu-card-inline">
      <ng-container [ngTemplateOutlet]="cardBodyTpl" [ngTemplateOutletContext]="{ canClose: false }"></ng-container>
    </div>
  } @else {
    @if (isOpen) {
      <div class="csu-overlay" role="dialog" aria-modal="true">
        <div class="csu-card" (click)="$event.stopPropagation()">
          <ng-container [ngTemplateOutlet]="cardBodyTpl" [ngTemplateOutletContext]="{ canClose: true }"></ng-container>
        </div>
        <div class="csu-backdrop" (click)="close()"></div>
      </div>
    }
  }


  <ng-template #cardBodyTpl let-canClose="canClose">
    <div class="csu-card-top">
      <div class="csu-badge">Coming Soon</div>
      @if (canClose) {
        <button type="button" class="csu-close" (click)="close()" aria-label="Close">
          ✕
        </button>
      }
    </div>

    <div class="csu-header">
      @if (title) {
        <div class="csu-title">{{ title }}</div>
      }
      <div class="csu-desc">{{ description }}</div>
    </div>

    @if (!isSubmitted) {
      <div class="csu-actions">
        <button
          type="button"
          class="csu-btn"
          (click)="startInterestSubmission('need')"
          [disabled]="isSubmitting"
          >
          <mat-icon class="csu-btn-icon">thumb_up_off_alt</mat-icon>
          <span>{{ isSubmitting ? 'Submitting...' : 'Yes, prioritize this' }}</span>
        </button>
        <button
          type="button"
          class="csu-btn"
          (click)="startInterestSubmission('curious')"
          [disabled]="isSubmitting"
          >
          <mat-icon class="csu-btn-icon">thumb_down_off_alt</mat-icon>
          <span>Not interested</span>
        </button>
        @if (allowFeedback && !pendingInterestType) {
          <button
            type="button"
            class="csu-btn csu-btn-link"
            (click)="toggleCommenting()"
            [disabled]="isSubmitting"
            >
            <mat-icon class="csu-btn-icon">chat_bubble_outline</mat-icon>
            <span>{{ isCommenting ? 'Hide comments' : 'Add comments' }}</span>
          </button>
        }
      </div>
    } @else {
      <div class="csu-submitted">
        <div class="csu-submitted-title">Thanks. We'll keep you posted.</div>
        <div class="csu-submitted-desc">Your interest helps us prioritize what to build next.</div>
      </div>
    }

    @if (submitError) {
      <div class="csu-error">{{ submitError }}</div>
    }

    @if (isCommenting && allowFeedback && !isSubmitted) {
      <div class="csu-expanded">
        <div class="csu-field">
          <label class="csu-label">
            {{ commentLabel }}
          </label>
          <textarea
            class="csu-textarea"
            [(ngModel)]="message"
            rows="3"
            [placeholder]="commentPlaceholder"
          ></textarea>
        </div>
        <div class="csu-actions csu-actions-comment">
          <button
            type="button"
            class="csu-btn csu-primary"
            (click)="submitCommenting()"
            [disabled]="isSubmitting"
            >
            {{ commentSubmitLabel }}
          </button>
          <button type="button" class="csu-btn" (click)="cancelCommenting()" [disabled]="isSubmitting">
            Cancel
          </button>
        </div>
      </div>
    }

    @if (learnMoreHref) {
      <a
        class="csu-learn"
        [href]="learnMoreHref"
        target="_blank"
        rel="noopener"
        >
        {{ learnMoreLabel }}
      </a>
    }
  </ng-template>
</div>
